import React, { FC, Suspense, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { costCategoryData, costCategoryDataLoading, error, inputSuggestions } from '../../../reducer/mappingFiles/selectors';
import { deleteItems, exportData, getFilters, loadCountries, loadData, massUpload, setError } from '../../../actions/CostCategoriesMapping/ikamapActions';
import { useParams } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import Spinner from 'react-bootstrap/esm/Spinner';
import { EditModal, IKAMapTable } from './components';
import * as constants from './constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { ICostCategoriesMap, IInputSugestion, IInputSuggestionsList, ISelectedFilters } from '../../../reducer/mappingFiles/_interfaces';
import ChannelCategoryDialogueBox from '../../../components/channelCategoryDialogueBox';
import { ERROR_TOAST_DUSATION } from '../../../constant/constants';
import Papa from 'papaparse';
import { SET_COST_CATEGORIES_DATA_LOADING } from '../../../reducer/mappingFiles/constants';

export const CostCategoriesMapping:FC = () => {
    const adminIds = localStorage.getItem('access_token') ? JSON.parse(localStorage.getItem('access_token') || '').user.form_admin_list : [];
    const { id } = useParams<{id:string}>();
    const dispatch = useDispatch();
    
    const errorMessage = useSelector(error);

    const data:ICostCategoriesMap[] = useSelector(costCategoryData);
    const dataLoading = useSelector(costCategoryDataLoading);
    const filters:IInputSuggestionsList = useSelector(inputSuggestions);

    const [openDeleteDialogueBox, setOpenDeleteDialogueBox] = useState<boolean>(false);
    const [openAddEditDialogueBox, setOpenAddEditDialogueBox] = useState<boolean>(false);
    const [selectedItem, setSelectedItem] = useState<ICostCategoriesMap | null>(null);

    //Filters
    const [selectedFilters, setSelectedFilters] = useState<ISelectedFilters>(constants.INITIAL_FILTERS);
    
    const handleAddEditDialogueBox = () => setOpenAddEditDialogueBox(!openAddEditDialogueBox)
    const handleDeleteDialogueBox = () => {
        setOpenDeleteDialogueBox(!openDeleteDialogueBox)
        if (!openDeleteDialogueBox) setSelectedItem(null);
    }

    const loadTableData = () => {
        dispatch(loadData(selectedFilters, id));
        dispatch(getFilters(id));
    }
    useEffect(() => {
        dispatch(loadCountries(id));
        loadTableData();
    }, []);

    useEffect(() => {
        if (errorMessage) {
            toast.error(errorMessage, {
                position: 'top-center',
                className: 'cutoff-popup',
                duration: ERROR_TOAST_DUSATION
            });

            const errorTimeout = setTimeout(() => dispatch(setError('')), ERROR_TOAST_DUSATION)
            return () => clearTimeout(errorTimeout)
        }
    }, [errorMessage])

    const handleExportButton = () => {
        dispatch(exportData())
    }

    const handleEdit = (ikaMap:ICostCategoriesMap | null) => {
        handleAddEditDialogueBox();
        setSelectedItem(ikaMap);
    }

    const handleDelete = (comment: string) => {
        handleDeleteDialogueBox();
        dispatch(deleteItems(
            comment,
            data.filter(({checked}) => checked).map(({id}) => id),
            id,
            selectedFilters
        ));
    }

    const uploadImportData = async (data:any) => {
        const response = await massUpload(data, id);
        return response;
    }

    const handleOnChange = (e:any) => {
        Papa.parse(e.target.files[0], {
            skipEmptyLines: true,
            header: true,
            complete: (results) => {
                toast.promise(uploadImportData(results.data), {
                    loading: "Loading. wait a moment!",
                    success: (response) => {
                        if (response.error) {
                            console.log("error in IKA Mapping API", response.results.message);
                            dispatch(setError(response.results.message));
                            dispatch({ type: SET_COST_CATEGORIES_DATA_LOADING, payload: false });
                            return 'Something went wrong.'
                        } else {
                            dispatch(loadData(constants.INITIAL_FILTERS, id));
                            return 'Data added successfully.'
                        }
                    },
                    error: 'Something went wrong.',
                },
                    {
                        position: 'top-center',
                        className: 'toast-popup',
                    });
            }
        })
        setTimeout(() => {
            e.target.value = ''
        }, 1500)

    }

    return (
        <Suspense fallback={<div>An error occured!</div>}>
            <div className="user-view-container">
                <div className="brand-category-header-container row">
                    <div className="col-8 brand-category-filter-container">
                    </div>
                    {adminIds.includes(id) ?
                        (<div className="col-4 brand-category-add-delete-export-button-container">
                            <div style={{ margin: "2rem 0rem 0rem 0rem", fontSize: ".75rem" }}>
                                <input
                                    type={"file"}
                                    id={"csvFileInput"}
                                    accept={".csv"}
                                    onChange={handleOnChange}
                                />
                            </div>
                            <button
                                className="brand-category-export-button mt-3 col"
                                type="button"
                                value="Export Data"
                                onClick={handleExportButton}
                            >
                                Export
                            </button>
    
                            {data.filter(({checked}) => checked).length === 0
                                ? (
                                    <button
                                        className="brand-category-button mt-3 col"
                                        type="button"
                                        value="+ Add New"
                                        onClick={() => handleEdit(null)}
                                    >
                                        <FontAwesomeIcon icon={faPlus} className="search-icon" size="1x" /> Add New
                                    </button>
                                ) : (
                                    <button
                                        className="brand-category-button mt-3 col"
                                        type="button"
                                        value="Delete"
                                        onClick={handleDeleteDialogueBox}
                                    >
                                        <FontAwesomeIcon icon={faTrash} className="search-icon" size="1x" /> Delete
                                    </button>
                                )}
                        </div>) : ""}
                </div>

                <div className="brand-category-body">
                    <div className='other-mfa-table-holder'>
                        <div className='channel-category-chips-container'>
                            {/* CSS Purpose */}
                        </div>
                        {dataLoading ? <div className="table-data-note"><Spinner animation="border" />
                            <p></p>
                        </div> : ""}
                        <IKAMapTable
                            adminIds={adminIds}
                            columns={constants.IKA_MAP_COLUMNS}
                            formId={id}
                            handleEdit={handleEdit}
                        />
                    </div>
                </div>

                <EditModal
                    selectedItem={selectedItem}
                    open={openAddEditDialogueBox}
                    toggleOpen={handleAddEditDialogueBox}
                />
                
                <ChannelCategoryDialogueBox
                    openDialogueBox={openDeleteDialogueBox}
                    handleDeleteDialogueBox={handleDeleteDialogueBox}
                    messageType="Delete"
                    message="Are you sure you want to delete this Map"
                    handleDelete={handleDelete}
                />
            </div>

            <Toaster />
        </Suspense>
    );
}